export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Confirmation", larga: "Confirmation de réservation", porque: "Le réglage général de votre compte est utilisé, pas un réglage propre à ce logement." },
    bienvenida: { etiqueta: "Bienvenue", larga: "Message de bienvenue", porque: "Pour l'instant c'est le message de bienvenue par défaut qui part, et ce n'est pas le vôtre." },
    checkin: { etiqueta: "Check-in", larga: "Envoi du check-in", porque: "Pour l'instant il part à l'heure par défaut, qui ne vous convient peut-être pas." },
    horas: { etiqueta: "Horaires", larga: "Heures d'arrivée et de départ", porque: "Sans vos horaires, on répond au voyageur avec ceux par défaut." },
    cerradura: { etiqueta: "Accès", larga: "Serrure et accès", porque: "Le voyageur arrive à la porte sans savoir comment ouvrir." },
    servicios: { etiqueta: "Services", larga: "Services du logement", porque: "Ni le moteur de réservation ni l'agent ne savent ce que vous proposez." },
    politicas: { etiqueta: "Règles", larga: "Politiques et règles", porque: "Le voyageur accepte des règles par défaut, pas les vôtres." },
  },
  titular: {
    listo: "Tout est prêt",
    unoAMedias: "Votre logement est à moitié configuré",
    variosAMedias: "Vos logements sont à moitié configurés",
    casi: "Il ne vous reste presque rien",
  },
  consecuencia: {
    bienvenida: "En attendant, vos voyageurs reçoivent le message de bienvenue par défaut, qui n'est pas le vôtre.",
    cerradura: "En attendant, des voyageurs arriveraient à la porte sans savoir comment ouvrir.",
    politicas: "En attendant, vos voyageurs acceptent des règles par défaut, pas les vôtres.",
    generico: "En attendant, ce sont les réglages par défaut qui s'appliquent, pas les vôtres.",
  },
  explicacion: {
    listoUno: "Votre logement peut désormais accueillir des voyageurs.",
    listoVarios: "Vos {n} logements peuvent désormais accueillir des voyageurs.",
    ajustesFinos: "Les réglages fins — tarifs, canaux, expériences — vous attendent dans chaque annonce quand vous voudrez.",
    faltaUno: "Il reste 1 logement à terminer.",
    faltanVarios: "Il reste {n} logements à terminer.",
  },
  resumen: {
    unAlojamiento: "1 logement",
    nAlojamientos: "{n} logements",
    unoPorPreparar: "1 à préparer",
    nPorPreparar: "{n} à préparer",
    listos: "{listos} prêts",
  },
  anillo: {
    rotulo: "configuré",
    ariaCorta: "{n}% configuré",
    ariaLarga: "{n}% de la configuration effectuée",
  },
  cifras: {
    listos: "prêts ·",
    ajustes: "réglages faits",
    ariaAjustes: "{hechas} sur {total} réglages faits",
    marcador: "{hechas} sur {total}",
  },
  ventana: {
    titulo: "Fermer cet avis ?",
    texto: "Il n'apparaîtra plus dans le panneau, même s'il vous reste des choses à configurer.",
    notaAntes: "Vous le récupérez quand vous voulez depuis",
    notaRuta: "Personnaliser → Afficher l'avis de configuration",
    cancelar: "Annuler",
    ocultar: "Fermer",
  },
  acciones: {
    verQueFalta: "Voir ce qu'il manque",
    buscar: "Rechercher un logement",
    sinResultados: "Aucun logement en attente ne porte ce nom.",
    verClaro: "Passer en clair",
    verOscuro: "Passer en sombre",
    ampliar: "Agrandir",
    ampliarAria: "Agrandir l'avis",
    minimizar: "Réduire",
    minimizarAria: "Réduire l'avis",
    entendido: "Compris",
    entendidoAria: "Compris, fermer l'avis",
    ocultar: "Fermer",
    ocultarAria: "Fermer l'avis de configuration",
    empezar: "Commencer",
    continuar: "Continuer",
    hecho: "fait",
    teToca: "À vous :",
    unidades: "{n} unités",
  },
};
